import { render, staticRenderFns } from "./Water.vue?vue&type=template&id=abdedd40&"
var script = {}
import style0 from "./Water.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Water.vue"
export default component.exports